<template>
  <div class="bs-wrapper">
      <!-- <s-h-header :onClickLeft="() => $bsUtils.nativeApi.goBack()" /> -->
      <div class="content" ref="content">
          <div class="result-background" :style="{
              background:`url(${isInvalidState
                ? require('../../assets/img/questionnaire/result_invalid.png')
                : require('../../assets/img/questionnaire/result_success.png')}) no-repeat`,
              backgroundSize: '100%'
          }"></div>
          <div class="result-text">{{($route.params.err && $route.params.err.message) || '获取问卷状态失败'}}</div>
      </div>
  </div>
</template>

<script>
// import SHHeader from '@/components/ShHeader';
export default {
  name: 'Fallback',

  mixins: [],

  components: {},

  props: {},

  data() {
    return {
  
    };
  },

  computed: {
    isInvalidState() {
      return !(this.$route.params.err  && this.$route.params.err.status && (this.$route.params.err.status === 5017))
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
  },
};
</script>

<style lang="less" scoped>
.result-background {
  width: 100px;
  height: 100px;
  margin: 146px auto 10px;
}
.result-text {
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  color: #717171;
}
</style>
